import { createFeatureSelector } from '@ngrx/store';
import { State } from './models';

export const featureConfigKey = 'company-configs';
export const featureSelector = createFeatureSelector<State>(featureConfigKey);
